<template>
    <div class="header modulewrap">
        <div class="langbarwrap">
            <div class="langbar realwrap"><a href="#" @click="setlangcur(1)" :class="{cs:$store.state.langcur == 1}">中文</a><span>|</span><a href="#" @click="setlangcur(2)" :class="{cs:$store.state.langcur != 1}">EN</a></div>
        </div>
        <div class="topbarwrap">
            <div :class="['topbarbox',isscroll?'topfixed':'']">
                <div class="topbar realwrap">
                    <div class="logo"><router-link to="/"><img :src="$store.state.logourl" /></router-link></div>
                    <div class="nav">
                        <ul>
                            <li v-for="item in navlist" :key="item.id" @mouseover="item.showmore=true" @click="item.showmore=true" @mouseout="item.showmore=false">
                                <template v-if="item.iscollege==1">
                                    <template v-if="topcollegeid>0 && topnavsort == item.kv">
                                        <a :class="{cs:topnavsort == item.kv}" href="#">{{$common.langinfo(collegecur.title,collegecur.title_en)}}</a>
                                        <transition name="fade">
                                            <div class="navmore" v-show="item.showmore">
                                                <dl>
                                                    <dd v-for="item2 in collegelist" :key="item2.id" v-if="item2.id!=topcollegeid"><router-link :to="item.url+'/'+item2.alias">{{$common.langinfo(item2.title,item2.title_en)}}</router-link></dd>
                                                </dl>
                                            </div>
                                        </transition>
                                    </template>
                                    <template v-else>
                                        <a :class="{cs:topnavsort == item.kv}" href="#">{{$common.langinfo(item.title,item.title_en)}}</a>
                                        <transition name="fade">
                                            <div class="navmore" v-show="item.showmore">
                                                <dl>
                                                    <dd v-for="item2 in collegelist" :key="item2.id"><router-link :to="item.url+'/'+item2.alias">{{$common.langinfo(item2.title,item2.title_en)}}</router-link></dd>
                                                </dl>
                                            </div>
                                        </transition>
                                    </template>
                                </template>
                                <template v-else>
                                    <router-link :class="{cs:topnavsort == item.kv}" :to="item.url">{{$common.langinfo(item.title,item.title_en)}}</router-link>
                                </template>
                            </li>
                            <li v-if="islogin" @mouseover="me.showmore=true" @mouseout="me.showmore=false">
                                <router-link to="/member" class="me" :title="$store.state.showname">
                                    <img :src="$common.getface($store.state.face)" /><br />
                                    <ffoverdot :title="$store.state.showname" myclass="nickname"></ffoverdot>
                                </router-link>
                                <transition name="fade">
                                    <div class="navmore menav" v-show="me.showmore">
                                        <dl>
                                            <dd class="mem" v-for="item in mynav" :key="item.id"><router-link :to="item.url"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link></dd>
                                            <dd class="mem"><a href="#" @click="$common.logout"><i class="iconfont icon-tuichudenglu"></i>{{$common.dicword('logout')}}</a></dd>
                                        </dl>
                                    </div>
                                </transition>
                            </li>
                            <li v-else><a href="#" @click="showlogin(1)">{{$common.dicword('login')}}</a><span>|</span><a href="#" @click="showlogin(3)">{{$common.dicword('reg')}}</a></li>
                        </ul>
                    </div>

                    <div class="navsmall" v-clickoutside="hidenav">
                        <div class="navmenu" @click="isshownav=!isshownav">
                            <i v-if="!islogin" class="iconfont icon-caidan"></i>
                            <img v-else :src="$common.getface($store.state.face)" />
                        </div>
                        <transition name="fade">
                            <div v-show="isshownav" class="navinfo">
                                <ul>
                                    <li v-for="(item,index) in navlist" :key="item.id" @click="shownavindex=index">
                                        <template v-if="item.iscollege==1">
                                            <template v-if="topcollegeid>9999990 && topnavsort == item.kv">
                                                <a :class="{cs:topnavsort == item.sortkey}" href="#"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(collegecur.title,collegecur.title_en)}}</a>
                                                <transition name="fade">
                                                    <div class="navmore" v-show="shownavindex==index">
                                                        <dl>
                                                            <dd v-for="item2 in collegelist" :key="item2.id" v-if="item2.id!=topcollegeid"><router-link :to="item.url+'/'+item2.alias" @click.native="hidenav">{{$common.langinfo(item2.title,item2.title_en)}}</router-link></dd>
                                                        </dl>
                                                    </div>
                                                </transition>
                                            </template>
                                            <template v-else>
                                                <a :class="{cs:topnavsort == item.kv}" href="#"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</a>
                                                <transition name="fade">
                                                    <div class="navmore" v-show="shownavindex==index">
                                                        <dl>
                                                            <dd v-for="item2 in collegelist" :key="item2.id"><router-link :class="{cs:topcollegeid == item2.id}" @click.native="hidenav" :to="item.url+'/'+item2.alias">{{$common.langinfo(item2.title,item2.title_en)}}</router-link></dd>
                                                        </dl>
                                                    </div>
                                                </transition>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <router-link :class="{cs:topnavsort == item.kv}" :to="item.url" @click.native="hidenav"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link>
                                        </template>
                                    </li>
                                    <li v-if="islogin" @click="shownavindex=99">
                                        <a href="#"><i class="iconfont icon-yonghu"></i>{{$common.dicword('membercenter')}}</a>
                                        <transition name="fade">
                                            <div class="navmore" v-show="shownavindex==99">
                                                <dl>
                                                    <dd class="mem" v-for="item in mynav" :key="item.id"><router-link :to="item.url" @click.native="hidenav"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link></dd>
                                                    <dd class="mem"><a href="/" @click.prevent="logout"><i class="iconfont icon-tuichudenglu"></i>{{$common.dicword('logout')}}</a></dd>
                                                </dl>
                                            </div>
                                        </transition>
                                    </li>
                                    <li v-else class="navlogin"><a href="#" @click="showlogin(1)">{{$common.dicword('login')}}</a><span>|</span><a href="#" @click="showlogin(3)">{{$common.dicword('reg')}}</a></li>
                                </ul>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Cheader',
        data() {
            return {
                isshowcollege: false,
                islogin: false,
                navlist: [],
                collegelist: [],
                me: {},
                mynav: [],
                isshownav: false,
                shownavindex: -1,
                isscroll: false//是否滚动，调整顶部导航
            };
        },
        props: {
            topcollegeid: {
                type: Number,
                default: 0
            }
        },
        computed: {
            collegecur: function () {
                return this.topcollegeid > 0 ? this.collegelist.find(item => item.id == this.topcollegeid) : {}
            },
            topnavsort: function () {
                return this.$store.state.topnavsort;
            }
        },
        methods: {
            setlangcur: function (v) {
                this.$store.commit('SET_LANGCUR', v);
                return false;
            },
            showlogin: function (v) {
                this.hidenav();
                this.$emit('showlogin', v);
            },
            hidenav: function () {
                window.setTimeout(() => { this.shownavindex = -1; }, 50);

                this.isshownav = false;
            },
            logout: function () {
                this.hidenav();
                this.$common.logout();
            },
            headerscroll: function () {
                let scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                this.isscroll = scrolltop > 150;
            }
        },
        mounted() {
            let imgalias = 'tc_logo' + this.$store.getters.tctype || 0;
            this.$common.fetch({ 'act': 'common_infoimg', 'exts': 'alias=' + imgalias }, res => {
                this.$store.dispatch('setlogourl', res.infodata.imgs);//异步设置logo
            });

            let jsondata = { 'postdata': { 'act': 'tc_header' }, 'msg': '' };
            this.$common.post(jsondata, res => {
                //this.$store.dispatch('setlogourl', res.infodataimg.imgs);//异步设置logo

                this.islogin = res.islogin == 1;
                this.$common.each(res.infodata, (item) => {
                    item.showmore = false;
                });
                this.navlist = res.infodata;
                this.collegelist = res.infodatacollege;
                if (this.islogin) {
                    this.$store.dispatch('setusername', res.infodatame.username);
                    this.$store.dispatch('setshowname', res.infodatame.showname || res.infodatame.realname || res.infodatame.username);
                    this.$store.dispatch('setface', res.infodatame.face);
                    this.$store.dispatch('setmemlev', res.infodatame.lev);

                    res.infodatame.showmore = false;
                    this.me = res.infodatame;
                    this.mynav = res.infodatanav;
                }

            });

            window.addEventListener('scroll', this.headerscroll, false)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.headerscroll, false);
        }
    };
</script>
